import * as React from 'react';
import Select from 'react-select';
import customStyles from './Dropdown.styles';

import i18n from 'helper/i18n';

import MobileDevice from 'components/helper/MobileDevice/MobileDevice';

type DropdownChangeHandler = (opts: { value: string | number; label: string }) => void;

type OptionValue = string | number;

export type OptionType = {
	value: OptionValue;
	label: string;
	clearableValue?: boolean;
};

export type DropdownProps = {
	id: string;
	options: Array<OptionType>;
	value: OptionValue;
	onChange: DropdownChangeHandler;
	label?: string;
	placeholder?: string;
	autoBlur?: boolean;
	onBlur?: () => void;
	clearable?: boolean;
	searchable?: boolean;
	disabled?: boolean;
	scrollMenuIntoView?: boolean;
};

/*
 * Returns a Dropdown
 *
 * @param {DropdownProps} props
 * @returns {Element}
 */

const defaultPlaceholder = i18n(`react.impulsCoach.components.dropdown.placeholder`);

export const Dropdown = ({
	label,
	id,
	placeholder = defaultPlaceholder,
	autoBlur = true,
	clearable = false,
	options,
	onChange,
	searchable = false,
	disabled = false,
	scrollMenuIntoView = false,
	value,
	onBlur,
}: DropdownProps) => {
	const selectedOption = options.find((option) => value === option.value);
	const hasSelectedOption = !!selectedOption;

	const handleBlur = () => {
		if (onBlur) {
			onBlur();
		}
	};

	return (
		<div className="a-dropdown">
			{label ? (
				<label htmlFor={id || ''} className="a-dropdown__label">
					{label}
				</label>
			) : (
				''
			)}
			<MobileDevice
				renderIOS={() => {
					return (
						<div className="a-dropdown__native-ios">
							<div className={`Select Select--single${hasSelectedOption ? ' has-value' : ''}`}>
								<div className="Select-control">
									<span className="Select-multi-value-wrapper">
										<span className="Select-value a-dropdown__button">
											<span className="Select-value-label" role="option" aria-selected>
												<select
													className="a-dropdown__select"
													name={id}
													value={value}
													onBlur={handleBlur}
													// placeholder={placeholder}
													disabled={disabled}
													onChange={(event: React.ChangeEvent<any>) => {
														const newValue = event.currentTarget.value;
														onChange({
															value: newValue,
															label: options.filter((option) =>
																Boolean(newValue.toString() === option.value.toString())
															)[0].label,
														});
													}}
												>
													{options.map((option) => (
														<option key={option.value} value={option.value}>
															{option.label}
														</option>
													))}
												</select>
											</span>
										</span>
									</span>
									<span className="Select-arrow-zone">
										<span className="Select-arrow" />
									</span>
								</div>
							</div>
						</div>
					);
				}}
				renderElse={() => (
					<Select
						name={id}
						autoBlur={autoBlur}
						value={{ value, label: selectedOption ? selectedOption.label : '' }}
						clearable={clearable}
						placeholder={placeholder}
						options={options}
						styles={customStyles as any}
						onChange={onChange as any}
						searchable={searchable}
						disabled={disabled}
						scrollMenuIntoView={scrollMenuIntoView}
					/>
				)}
			/>
		</div>
	);
};

Dropdown.displayName = 'Dropdown';

export default Dropdown;
